// extracted by mini-css-extract-plugin
export default {"wrapper":"PaInfo_wrapper__EoBre","pa-logo":"PaInfo_pa-logo__4XPmN"};